module.exports = __webpack_public_path__ + "static/media/symptomChecker.a38f5b66.svg";